import { useMutation, useQuery } from '@tanstack/react-query';
import type { Canvas } from '@avslack/shared';
import { apiFetch } from '../lib/api';

/**
 * HIVAS-JEGYZET (versenyaudit H4).
 *
 * A jegyzet a csatorna rendes vaszna, csak tudja, melyik hivashoz keszult.
 * Megnyitaskor jon letre; hivasonkent egy van belole.
 */

/** A hivas jegyzete - ha meg nincs, most keszul el. */
export function useOpenHuddleNotes() {
  return useMutation({
    mutationFn: (huddleId: string) =>
      apiFetch<{ canvas: Canvas }>(`/api/huddles/${huddleId}/notes`, { method: 'POST' }).then(
        (r) => r.canvas,
      ),
  });
}

/**
 * Mely hivasoknak van jegyzete - a csatorna hivas-soraihoz, EGY kerdessel
 * (ugyanugy, mint az atiratok allapota).
 */
export function useHuddleNotes(huddleIds: string[]) {
  const key = [...huddleIds].sort().join(',');
  return useQuery({
    queryKey: ['huddle-notes', key],
    enabled: huddleIds.length > 0,
    queryFn: () =>
      apiFetch<{ notes: Record<string, string> }>(
        `/api/huddle-notes?huddleIds=${encodeURIComponent(key)}`,
      ).then((r) => r.notes),
    staleTime: 30_000,
  });
}
